import { additionalProductGroupAttributes as fixedPriceProjectAdditionalAttributes } from '../lib/productGroups/fixed-price-project';
import { getContestTier } from '../util/getContestTier';
import type { CurrencyCode } from '@99designs/i18n';
import type { ProductDetailsQuery } from '../graphql/ProductDetails.generated';
import type {
    ContestProduct,
    FixedPriceProjectProduct,
    FixedPriceProjectProductGroupKey,
} from '../types';

export const mapDataToProductTypeArray = (
    data: ProductDetailsQuery
): ContestProduct[] | FixedPriceProjectProduct[] =>
    data.products
        .map((product) => {
            if (product.__typename === 'ProductContest') {
                return {
                    key: product.key,
                    name: product.name,
                    title: product.title,
                    description: product.description,
                    category: product.category,
                    details: product.contestDetails,
                    pricing: {
                        amountInCents: product.pricing.amount.amountInCents,
                        currency: product.pricing.amount.currency as CurrencyCode,
                    },
                    tier: getContestTier(product.key),
                } as ContestProduct;
            }

            if (product.__typename === 'ProductFixedPriceProject') {
                const fixedPriceProject = {
                    key: product.key,
                    name: product.name,
                    title: product.title,
                    description: product.description,
                    category: product.category,
                    details: product.details,
                    additionalDetails: product.additionalDetails,
                    pricing: {
                        amountInCents: product.pricing.amount.amountInCents,
                        currency: product.pricing.amount.currency as CurrencyCode,
                    },
                    ...(fixedPriceProjectAdditionalAttributes[
                        product.name as FixedPriceProjectProductGroupKey
                    ] || {}),
                } as FixedPriceProjectProduct;

                if (product.disclaimer) {
                    fixedPriceProject.disclaimer = product.disclaimer;
                }

                return fixedPriceProject;
            }

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return null as any;
        })
        .filter(Boolean);
